import React, { useState } from 'react';
import { Box, Fab, Modal, Fade, Backdrop, Tooltip, IconButton } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import ChatbotPage from '../pages/ChatbotPage';


const style = {
  position: 'fixed' as const,
  bottom: 32,
  right: 32,
  zIndex: 1300,
};

const modalStyle = {
  position: 'fixed' as const,
  bottom: 80,
  right: 40,
  width: 380,
  maxWidth: '95vw',
  height: 600,
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

const ChatbotWidget: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Posso ajudar?" placement="left">
        <Fab
          color="primary"
          aria-label="chat"
          sx={style}
          onClick={() => setOpen(true)}
          style={{
            animation: 'pulse 2s infinite',
            background: 'linear-gradient(135deg, #123A61 60%, #2DD4BF 100%)',
            color: '#fff',
          }}
        >
          <ChatIcon fontSize="large" />
        </Fab>
      </Tooltip>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
              <IconButton size="small" onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0 }}>
              <ChatbotPage isWidget onClose={() => setOpen(false)} />
            </Box>
          </Box>
        </Fade>
      </Modal>
      <style>
        {`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(18, 58, 97, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(18, 58, 97, 0); }
            100% { box-shadow: 0 0 0 0 rgba(18, 58, 97, 0); }
          }
        `}
      </style>
    </>
  );
};

export default ChatbotWidget; 